import {
    Upload,
    UploadFileInfo,
    UploadFileRestrictions,
    UploadListItemProps,
} from '@progress/kendo-react-upload';
import { useMemo } from 'react';

const CustomListItemUI = (props: UploadListItemProps) => (
    <div>
        {props.files.map((file) => (
            <div key={file.name}>{file.name}</div>
        ))}
    </div>
);

export type SingleUploadProps = {
    file: UploadFileInfo | undefined;
    onChange: (file: UploadFileInfo) => void;
    restrictions: UploadFileRestrictions;
    saveUrl?: string;
    disabled?: boolean;
    showActionButtons?: boolean;
};

export function SingleUpload({
    file,
    onChange,
    restrictions,
    saveUrl,
    disabled = false,
    showActionButtons = false,
}: SingleUploadProps) {
    const files = useMemo<UploadFileInfo[]>(() => (file ? [file] : []), [file]);
    return (
        <Upload
            className="flex-grow-1"
            autoUpload={false}
            batch={false}
            files={files}
            multiple={false}
            withCredentials={false}
            listItemUI={CustomListItemUI}
            restrictions={restrictions}
            showActionButtons={showActionButtons}
            disabled={disabled}
            onAdd={(event) => {
                if (event.newState.length > 0) {
                    onChange(event.newState[0]);
                }
            }}
            saveUrl={saveUrl}
        />
    );
}
